module.exports = __webpack_public_path__ + "static/media/lat.8e3ca01d.mp3";